import React, { useCallback, useEffect, memo, useState } from "react";
import { Button, Spinner, Table } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronRight,
  faLock,
  faLockOpen,
  faSpinner,
} from "@fortawesome/free-solid-svg-icons";

import {
  adminBlockVenueAction,
  getAdminVenuesAction,
} from "../../Services/Store/Actions/VanuesAction";
import VenuesSpaceList from "../Admin/Components/VenuesSpaceList";
import AddVenue from "../../Components/Modals/AddVenue";
import { VenueTypes } from "../../Constants/Interfaces";
import { formatArea, showToast } from "../../utils/helpers";
import PanelWrapper from "../User/PanelWrapper";
import ConfirmationModal from "../../Components/ConfirmationModal";
import ActionMenu from "../../Components/ActionMenu";
import Pagination from "../../Components/Pagination";

const PropertiesList = () => {
  const dispatch = useDispatch();
  const { adminVanues } = useSelector((state: any) => state.venues);

  const [loading, setLoading] = useState(false);
  const [venueList, setVenueList] = useState([]);
  const [deletingVenue, setDeletingVenue] = useState({});

  const [addNew, setNewVenue] = useState({ show: false, item: {} });

  const [pagination, setPagination] = useState({
    totalItems: null,
    itemsPerPage: null,
    currentPage: null,
    totalPages: null,
    nextPage: null,
  });

  const [showRightPanel, setShowRightPanel] = useState({
    show: false,
    item: {},
  });

  const [blockConfirm, setBlockConfirm] = useState<{
    show: boolean;
    item: any;
  }>({ show: false, item: null });

  const getVenueList = useCallback((page = 1) => {
    if (!loading) {
      setLoading(true);

      const data = {
        page,
        limit: 15,
        addresss: "",
        size: "",
        spaces: "",
      };

      getAdminVenuesAction(data, dispatch)
        .then((res) => {
          //
          if (res.type === "success") {
            setPagination(res.pagination);
          }
        })
        .catch((err) => {
          //
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, []);

  const deleteVenue = (item: VenueTypes & { id: string }) => {
    const venueId = item.id;

    if (!deletingVenue[venueId]) {
      setDeletingVenue({ ...deletingVenue, [venueId]: true });

      adminBlockVenueAction({ id: venueId }, dispatch)
        .then((res) => {
          showToast(res.type, res.message);
        })
        .catch((err) => {
          showToast("error", err.message);
        })
        .finally(() =>
          setDeletingVenue({ ...deletingVenue, [venueId]: false })
        );
    }
  };

  useEffect(() => {
    if (adminVanues) {
      setVenueList(adminVanues);
    } else {
      setVenueList([]);
    }
  }, [adminVanues]);

  useEffect(() => {
    getVenueList();
  }, []);

  const [editorData, setEditorData] = useState("<p>Hello, world!</p>");

  return (
    <PanelWrapper type="admin">
      <div className="container">
        <div className="page-header">
          <h2>Venues</h2>

          <Button onClick={() => setNewVenue({ show: true, item: {} })}>
            Add New
          </Button>
        </div>

        <div className="page-content-card">
          <div className="content-card-header">
            <h3>List of Venues</h3>

            {/* <div className="filter-area">
                  <div className="form-group">
                    <select className="form-control">
                      <option>Location</option>
                      <option value="Location1">Location 1</option>
                      <option value="Location2">Location 2</option>
                    </select>
                  </div>

                  <div className="form-group">
                    <select className="form-control">
                      <option>Property Size</option>
                      <option value="1">1</option>
                      <option value="2">2</option>
                    </select>
                  </div>

                  <div className="form-group">
                    <select className="form-control">
                      <option>Number of Space</option>
                      <option value="1">1</option>
                      <option value="2">2</option>
                    </select>
                  </div>
                </div> */}
          </div>

          <div className="listing-tables">
            <Table responsive>
              <thead>
                <tr>
                  <th>Property Name</th>
                  <th>Spaces</th>
                  <th>Location</th>
                  <th>Property Size</th>
                  <th>Status</th>
                  <th className="action-col">Action</th>
                </tr>
              </thead>

              <tbody>
                {loading && (
                  <tr>
                    <td colSpan={6} align="center">
                      <FontAwesomeIcon icon={faSpinner} spin />
                    </td>
                  </tr>
                )}

                {!loading && (!venueList || venueList.length === 0) && (
                  <tr>
                    <td colSpan={6} align="center">
                      No Venues Created
                    </td>
                  </tr>
                )}

                {!loading &&
                  venueList &&
                  venueList.map((item, index) => {
                    return (
                      <tr key={`property-${index}`}>
                        <td
                          className="as-link"
                          onClick={() => setNewVenue({ show: true, item })}
                        >
                          {item.name}
                        </td>
                        <td>
                          {Array.isArray(item.spaces)
                            ? item.spaces.length
                            : item.spaces_count ?? item.spacesCount ?? 0}
                        </td>
                        <td>{item?.address}</td>
                        <td>{formatArea(item?.area)} sqft</td>
                        <td>
                          {(() => {
                            const status = String(
                              item?.status || ""
                            ).toLowerCase();
                            const label =
                              status === "blocked"
                                ? "Blocked"
                                : status === "draft"
                                ? "Draft"
                                : "Published";
                            const cls =
                              status === "blocked"
                                ? "status-blocked"
                                : status === "draft"
                                ? "status-draft"
                                : "status-published";
                            return (
                              <span className={`status-badge ${cls}`}>
                                {label}
                              </span>
                            );
                          })()}
                        </td>
                        <td className="action-col">
                          <ActionMenu
                            items={[
                              {
                                label: "Manage Spaces",
                                icon: faChevronRight,
                                onClick: () =>
                                  setShowRightPanel({ show: true, item }),
                              },
                              {
                                label:
                                  item?.status === "blocked"
                                    ? "Unblock"
                                    : "Block",
                                icon:
                                  item?.status === "blocked"
                                    ? faLock
                                    : faLockOpen,
                                variant:
                                  item?.status === "blocked"
                                    ? "default"
                                    : "danger",
                                loading: deletingVenue[item.id],
                                onClick: () =>
                                  setBlockConfirm({ show: true, item }),
                              },
                            ]}
                          />
                        </td>
                      </tr>
                    );
                  })}
              </tbody>

              <tfoot>
                <tr>
                  <td colSpan={6}>
                    <Pagination
                      pagination={pagination}
                      onPageChange={(page) => getVenueList(page)}
                    />
                  </td>
                </tr>
              </tfoot>
            </Table>
          </div>
        </div>
      </div>

      {showRightPanel.show && (
        <VenuesSpaceList
          show={showRightPanel.show}
          venue={showRightPanel.item}
          onClose={() => setShowRightPanel({ show: false, item: {} })}
          addNew={true}
        />
      )}

      {addNew.show && (
        <AddVenue
          show={addNew.show}
          item={addNew.item}
          closeModal={() => setNewVenue({ show: false, item: {} })}
        />
      )}

      {blockConfirm.show && (
        <ConfirmationModal
          show={blockConfirm.show}
          heading={
            blockConfirm?.item?.status === "blocked"
              ? "Unblock Venue"
              : "Block Venue"
          }
          message={`Are you sure you want to ${
            blockConfirm?.item?.status === "blocked" ? "unblock" : "block"
          } the venue ${blockConfirm?.item?.name || ""}?`}
          closeModal={() => setBlockConfirm({ show: false, item: null })}
          buttons={[
            {
              text: "Yes",
              action: () => {
                deleteVenue(blockConfirm.item);
                setBlockConfirm({ show: false, item: null });
              },
            },
            {
              text: "Cancel",
              variant: "outline-dark",
              className: "confirmation-cancel-btn",
              action: () => setBlockConfirm({ show: false, item: null }),
            },
          ]}
        />
      )}
    </PanelWrapper>
  );
};

export default PropertiesList;
